import React, { ChangeEvent } from 'react';
import { usePagination } from '@material-ui/lab/Pagination';
import cn from 'classnames';
import FsPaginationVectorArrowIcon from 'ui-elements/icons/FsPaginationVectorArrow';
import { FsDirection } from 'globals/types';
import FsPaginationDotsIcon from 'ui-elements/icons/FsPaginationDots';
import { PaginationInfo } from 'models/detached-actions/report';
import { useStyles } from './FsPagination.style';
import { NextPrevType } from './FsPagination.types';
import { Wrapper } from './FsPagination.style-elements';

interface FsPaginationProps {
  onPageChange?: (pageNumber: number) => void;
  activePageNumber?: number;
  paginationInfo: PaginationInfo;
}

const FsPagination: React.FC<FsPaginationProps> = ({
  onPageChange,
  activePageNumber,
  paginationInfo,
}) => {
  const {
    defaultItem,
    selectedItem,
    prevNextItem,
    ul,
    li,
    pageItem,
  } = useStyles();

  const handleChange = (_: ChangeEvent<unknown>, pageNumber: number): void => {
    if (onPageChange) onPageChange(pageNumber);
  };

  const { items } = usePagination({
    // TODO: waiting for API
    count: 10 || paginationInfo.numberOfPages,
    page: activePageNumber || 1,
    onChange: handleChange,
  });

  return (
    <Wrapper>
      <nav>
        <ul className={ul}>
          {items.map(({ page, type, selected, ...item }, index) => {
            let children = null;

            if (type === 'start-ellipsis' || type === 'end-ellipsis') {
              children = <FsPaginationDotsIcon />;
            } else if (type === 'page') {
              children = (
                <button
                  type="button"
                  className={cn(defaultItem, pageItem, {
                    [selectedItem]: selected,
                  })}
                  {...item}
                >
                  {page}
                </button>
              );
            } else if (!item.disabled) {
              children = (
                <button
                  className={cn(defaultItem, prevNextItem)}
                  type="button"
                  {...item}
                >
                  {type === NextPrevType.NEXT && (
                    <FsPaginationVectorArrowIcon />
                  )}
                  {type === NextPrevType.PREV && (
                    <FsPaginationVectorArrowIcon direction={FsDirection.LEFT} />
                  )}
                </button>
              );
            }

            return (
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={li}
              >
                {children}
              </li>
            );
          })}
        </ul>
      </nav>
    </Wrapper>
  );
};

export default FsPagination;
